import { getAxiosClient } from "../../axios-client";
import {
  UpdateOfferPositionRequestBody,
  UpdateOfferPositionResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerPositionUpdate = async (
  body: UpdateOfferPositionRequestBody
) => {
  return await axiosClient.ax.put<UpdateOfferPositionResponse>(
    "/Offers/UpdateOfferPossition",
    body
  );
};
